import { render, staticRenderFns } from "./UserProfileAccountFormTab.vue?vue&type=template&id=9c5bcc06&scoped=true"
import script from "./UserProfileAccountFormTab.vue?vue&type=script&lang=js"
export * from "./UserProfileAccountFormTab.vue?vue&type=script&lang=js"
import style0 from "./UserProfileAccountFormTab.vue?vue&type=style&index=0&id=9c5bcc06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5bcc06",
  null
  
)

export default component.exports